<script setup lang="ts">
type Props = {
    text: number | string
}
defineProps<Props>()
defineEmits<{ (e: 'click'): void }>()
</script>

<template>
    <a @click="$emit('click')" class="clickable-span" v-bind="$attrs">{{ text }}</a>
</template>
